import React, { lazy } from 'react';
import { AuthRoute } from '../auth/components';
import { USER_ROLE } from '@utils/authorisation';
import sagas from './sagas';

const ManagePortals = lazy(() => import('./pages/ManagePortals'));
const OpenPortal = lazy(() => import('./pages/OpenPortal'));
const openRoles = [USER_ROLE.Specialist, USER_ROLE.Conveyancer, USER_ROLE.OperationsManager, USER_ROLE.Admin, USER_ROLE.Supervisor];
const manageRoles = [USER_ROLE.Specialist, USER_ROLE.Conveyancer, USER_ROLE.Admin];

const portalsModule = {
  routes: [
    <AuthRoute key="portals-manage" exact path="/portals/manage" component={ManagePortals} headerType={'private'} isSpecialistOnly authorization={manageRoles} />,
    <AuthRoute key="portals-open" exact path="/portals/open" component={OpenPortal} headerType={'private'} isSpecialistOnly authorization={openRoles} />,
  ],
  sagas
};

export default portalsModule;
